import React, { useState, useEffect, useCallback } from "react";
import { OTHER_BUDGET_CODES as BUDGET_CODES } from "./budjectCodes";
import { useSelector } from "react-redux";
import { PRE_PROPOSAL_STATUS, yearsFields } from "../../Constants";
import {
  applicantSelector,
  isLeaderSelector,
  canEditSelector,
} from "../../../../store/applicantsSlice";
import { useLoading } from "../../../../providers/loadingProvider";
import {
  pisColleaguesSelector,
  proposalSelector,
} from "../../../../store/proposalSlice";
import BudgetScreen from "./BudgetScreen";

export default function Other() {
  const loading = useLoading();
  const proposal = useSelector(proposalSelector);
  const [proposalApplicants, setProposalApplicants] = useState([]);
  const applicant = useSelector(applicantSelector);
  const isLeader = useSelector(isLeaderSelector);
  const canEdit = useSelector(canEditSelector);
  const colleagues = useSelector(pisColleaguesSelector);

  const buildTableConfig = useCallback(
    (numberOfYears, codes) => {
      if (yearsFields.length < numberOfYears)
        throw new Error("yearsFields length is less then number of years");

      const yearsCols = [];
      for (let i = 0; i < numberOfYears; i++) {
        const element = yearsFields[i];
        yearsCols.push({
          id: element,
          label: numberOfYears === 1 ? `Cost` : `Year ${i + 1}`,
          field: element,
          type: "number",
        });
      }
      // if (numberOfYears > 1) {
      //   yearsCols.push({
      //     id: "total",
      //     label: "Total",
      //     type: "calculated",
      //     skipValidation: true,
      //     calculation: (row) =>
      //       yearsFields.map((f) => +row[f] || 0).reduce((a, b) => a + b, 0),
      //   });
      // }
      const activeProposalFields = [
        // {
        //   id: "description",
        //   label: "Description",
        //   field: "description",
        // },
      ];

      const aditionalFieds =
        proposal.status === PRE_PROPOSAL_STATUS ? [] : activeProposalFields;
      const budgetType =
        codes.length > 1
          ? [
              {
                id: "budgetTypeInt",
                label: "Budget Code",
                field: "budgetTypeInt",
                type: "options",
                options: codes,
                width: 3,
              },
            ]
          : [];
      return {
        idField: "budgetClauseId",
        disableEdit: !canEdit,
        editOnlyId: applicant.id,
        editOnlyIdFiled: "applicantGranteeId",
        columns: [
          {
            id: "applicantGranteeId",
            label: "PI Name",
            field: "applicantGranteeId",
            type: "options",
            width: 3,
            options: proposalApplicants,
            disabled: !isLeader,
            skipValidation: true,
            value: applicant.id,
          },
          ...aditionalFieds,
          ...budgetType,
          {
            id: "justification",
            label: "Justification",
            field: "justification",
          },
          ...yearsCols,
        ],
      };
    },
    [applicant.id, canEdit, isLeader, proposalApplicants, proposal]
  );

  const getProposalApplicants = useCallback(async () => {
    if (!colleagues) return [];
    return colleagues.map((c) => ({
      id: c.id,
      name: c.name,
    }));
  }, [colleagues]);

  useEffect(() => {
    const getData = async () => {
      const [shortProposalApplicants] = await Promise.all([
        getProposalApplicants(),
      ]);
      setProposalApplicants(
        shortProposalApplicants.map((a) => ({ ...a, label: a.name }))
      );
    };
    getData();
  }, [getProposalApplicants, loading]);

  return (
    <BudgetScreen
      buildTableConfig={buildTableConfig}
      title="Other"
      infoField="Other"
      colleagues={colleagues}
      releventCodes={BUDGET_CODES}
    />
  );
}
